import axios from 'axios';
var live="https://d6-halolive.herokuapp.com/"
  // var live="https://d6-halo.herokuapp.com/"
    // var live='http://127.0.0.1:8000/'
    // var live='http://192.168.1.7:8000/'

const api = axios.create({
  baseURL: live, 
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export default api;
